module.exports = __webpack_public_path__ + "static/media/placeholder_image.6e0ff914.jpeg";